import type { SlateLeafConstant } from '@atlas/renderer';

export default function getConstantValue(constant: SlateLeafConstant) {
    if (constant.endsWith(variableSuffix)) {
        return constant.slice(0, -variableSuffix.length);
    }

    if (constant.endsWith(toolSuffix)) {
        return constant.slice(0, -toolSuffix.length);
    }

    const suffix = constant.endsWith(articleSuffix)
        ? articleSuffix
        : constant.endsWith(mentionSuffix)
        ? mentionSuffix
        : null;
    if (!suffix) return '';

    const preSuffixIndex = constant.lastIndexOf(':', constant.length - suffix.length - 1);
    if (!~preSuffixIndex) return '';
    return constant.slice(0, preSuffixIndex);
}

// #region Helpers

const toolSuffix = ':tool';
const variableSuffix = ':variable';
const articleSuffix = ':article';
const mentionSuffix = ':mention';

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('getConstantValue', () => {
        it('returns empty string for invalid constants', () => {});

        it('returns value part for valid constants', () => {
            expect(getConstantValue('{{first_name}}:variable')).toBe('{{first_name}}');
            expect(getConstantValue('Article Title:article_title:article')).toBe('Article Title');
            expect(getConstantValue('Article Title: With Subtitle:article_title_with_subtitle:article')).toBe(
                'Article Title: With Subtitle',
            );
            expect(getConstantValue('Full Name:usr-full-name:mention')).toBe('Full Name');
        });
    });
}

// #endregion
